// reducer.js
import * as actionTypes from "./actionsTypes";

const initialState = {
  currentPage: 0,
  pageSize: 20,
  customFilters: [],
  value: "",
  sorting: [],
  sortField: "nom",
  sortOrder: "asc",
  activeTab: "details",
  //Nouveau
  query: "",
  actif: {},
  selectedOptionFilters: null,
  selectedOptionId: null,
  column: [],
};

const FiltreInvestissements = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_VALUE_INVESTISSEMENT:
      return {
        ...state,
        value: action.payload,
      };
    case actionTypes.SET_CURRENT_PAGE_INVESTISSEMENT:
      return {
        ...state,
        currentPage: action.payload,
      };
    case actionTypes.SET_CUSTOM_FILTERS_INVESTISSEMENT:
      return {
        ...state,
        customFilters: action.payload,
      };
    case actionTypes.SET_SORT_FIELD_INVESTISSEMENT:
      return {
        ...state,
        sortField: action.payload,
      };
    case actionTypes.SET_PAGE_SIZE_INVESTISSEMENT:
      return {
        ...state,
        pageSize: action.payload,
      };
    case actionTypes.SET_SORTING_INVESTISSEMENT:
      return {
        ...state,
        sorting: action.payload,
      };
    case actionTypes.SET_ORDER_INVESTISSEMENT:
      return {
        ...state,
        sortOrder: action.payload,
      };
    case actionTypes.SET_ACTIVE_TAB_INVESTISSEMENT:
      return {
        ...state,
        activeTab: action.payload,
      };
    case actionTypes.SET_QUERY_INVESTISSEMENT:
      return {
        ...state,
        query: action.payload,
      };
    case actionTypes.SET_ACTIF_INVESTISSEMENT:
      return {
        ...state,
        actif: action.payload,
      };
    case actionTypes.SET_SELECTED_OPTION_FILTERS_INVESTISSEMENT:
      return {
        ...state,
        selectedOptionFilters: action.payload,
      };
    case actionTypes.SET_SELECTED_OPTION_ID_INVESTISSEMENT:
      return {
        ...state,
        selectedOptionId: action.payload,
      };
    case actionTypes.SET_COLUMN_INVESTISSEMENT:
      return {
        ...state,
        column: action.payload,
      };
    default:
      return state;
  }
};

export default FiltreInvestissements;
